class ThumbsSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderWrapper = this.querySelector(".swiper-wrapper");
    this.sliderThumbsOptions = {
      spaceBetween: 8,
      slidesPerView: 4,
      watchSlidesProgress: true,
      navigation: {
        nextEl: this.querySelector(".swiper-button--next"),
        prevEl: this.querySelector(".swiper-button--prev"),
      },
      breakpoints: {
        750: {
          slidesPerView: 6,
          spaceBetween: 8,
        },
        990: {
          slidesPerView: 8,
          spaceBetween: 8,
        },
        1200: {
          slidesPerView: 10,
        },
      },
    };

    this.thumbsSlider = new Swiper(
      this.querySelector(".swiper-thumbs"),
      this.sliderThumbsOptions
    );

    // Get window width
    this.windowWidth = window.innerWidth;
    this.slideWidth = this.windowWidth > 576 ? 450 : this.windowWidth - 50;

    this.sliderMainOptions = {
      a11y: false,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: ".next",
        prevEl: ".prev",
      },
      width: this.slideWidth,
      thumbs: {
        swiper: this.thumbsSlider,
      },
    };

    this.slider = new Swiper(
      this.querySelector(".swiper-main"),
      this.sliderMainOptions
    );
  }
}

customElements.define("thumbs-slider", ThumbsSlider);
